var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    width: "67.000000pt",
    height: "40.000000pt",
    viewBox: "28.56 47.5 143.44 120.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,176.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b3fa6",
    d: "M466 984 c-48 -75 -86 -139 -84 -144 5 -13 532 -560 540 -560 9 0 518 540 525 557 3 7 -34 74 -82 148 l-87 135 -362 0 -362 0 -88 -136z m404 98 c0 -10 -198 -207 -204 -201 -6 6 -76 190 -76 200 0 5 63 9 140 9 77 0 140 -3 140 -8z m370 -5 c0 -13 -56 -173 -67 -190 -5 -9 -203 181 -203 195 0 5 61 8 135 8 105 0 135 -3 135 -13z m-215 -107 l110 -110 -220 0 -220 0 110 110 c60 61 110 110 110 110 0 0 50 -49 110 -110z m-425 -13 c18 -48 31 -90 28 -93 -3 -2 -49 -3 -102 -2 l-96 3 62 97 c35 54 66 94 69 90 4 -4 21 -46 39 -95z m744 -1 c32 -48 55 -90 53 -93 -3 -2 -47 -2 -100 -1 l-95 3 36 98 c19 54 38 95 42 90 4 -4 33 -48 64 -97z m-592 -340 c54 -115 97 -210 95 -212 -3 -3 -368 373 -396 409 -13 17 -8 18 94 15 l107 -3 100 -209z m396 205 c-24 -66 -224 -479 -229 -473 -8 7 -229 470 -229 478 0 2 104 4 231 4 134 0 229 -4 227 -9z m131 -123 c-68 -72 -161 -170 -207 -217 l-82 -86 24 55 c29 68 154 338 167 363 8 14 25 17 115 17 l106 0 -123 -132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0b3fa6",
    d: "M650 1038 c0 -7 8 -30 18 -51 l17 -38 50 50 49 51 -67 0 c-47 0 -67 -4 -67 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0b3fa6",
    d: "M1051 1048 c2 -2 27 -24 55 -51 l50 -47 16 50 16 50 -71 0 c-38 0 -68 -1 -66 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0b3fa6",
    d: "M522 934 l-22 -34 40 0 c39 0 40 0 28 28 -18 43 -22 43 -46 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0b3fa6",
    d: "M1273 935 l-11 -35 34 0 33 0 -20 35 c-12 19 -22 35 -23 35 -2 0 -7 -16 -13 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0b3fa6",
    d: "M615 700 c49 -49 90 -90 91 -90 1 0 -16 41 -39 90 l-42 90 -50 0 -50 0 90 -90z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0b3fa6",
    d: "M1186 728 c-46 -104 -58 -133 -49 -123 5 6 47 49 93 98 l84 87 -50 0 -49 0 -29 -62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0b3fa6",
    d: "M1683 863 c4 -87 7 -224 7 -305 0 -125 2 -148 15 -148 13 0 15 41 15 305 l0 305 -22 0 c-21 0 -21 -1 -15 -157z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.52125f3e19f89c85667714b7d755fe87.svg";
export { ForwardRef as ReactComponent };